import React from 'react';
import {
  Box, FormControl, InputLabel, Select, MenuItem,
  Chip, Typography, Button, Paper
} from '@mui/material';
import {
  FilterList as FilterIcon,
  Clear as ClearIcon,
  School as SchoolIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const GradeFilters = ({ filters, onFiltersChange, availableYears = [] }) => {
  const { t } = useTranslation();

  const handleChange = (name, value) => {
    if (name === 'year') {
      onFiltersChange({ year: value, session: '' });
    } else {
      onFiltersChange({ ...filters, [name]: value });
    }
  };

  const clearFilters = () => onFiltersChange({ year: '', session: '' });

  const hasActive = filters.year || filters.session;
  const yearDone  = !!filters.year;

  return (
    <Paper elevation={0} sx={{ mb: 3, borderRadius: 3, border: '1.5px solid #e8ecef', overflow: 'hidden' }}>

      {/* Header */}
      <Box sx={{
        px: 2.5, py: 1.8, bgcolor: '#f8f9fa', borderBottom: '1px solid #e8ecef',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FilterIcon sx={{ fontSize: 18, color: '#64748b' }} />
          <Typography variant="subtitle2" fontWeight={700} color="text.secondary">
            {t('gf_title')}
          </Typography>
        </Box>
        {hasActive && (
          <Button size="small" startIcon={<ClearIcon />} onClick={clearFilters} color="error" sx={{ borderRadius: 2, fontSize: '0.78rem' }}>
            {t('gf_clear')}
          </Button>
        )}
      </Box>

      {/* Filters Row */}
      <Box sx={{ px: 2.5, py: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>

        {/* Year */}
        <Box sx={{ flex: '1 1 200px', minWidth: 180 }}>
          <FormControl fullWidth size="small">
            <InputLabel>{t('filterByYear')}</InputLabel>
            <Select
              value={filters.year || ''}
              onChange={e => handleChange('year', e.target.value)}
              label={t('filterByYear')}
              sx={{ borderRadius: 2 }}
            >
              <MenuItem value=""><em>{t('allYears')}</em></MenuItem>
              {availableYears.map(y => (
                <MenuItem key={y} value={y}>{y} / {parseInt(y) + 1}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Session */}
        <Box sx={{ flex: '1 1 200px', minWidth: 180 }}>
          <FormControl fullWidth size="small" disabled={!yearDone}>
            <InputLabel>{t('gf_sessionLabel')}</InputLabel>
            <Select
              value={filters.session || ''}
              onChange={e => handleChange('session', e.target.value)}
              label={t('gf_sessionLabel')}
              sx={{ borderRadius: 2 }}
            >
              <MenuItem value=""><em>{t('allSessions')}</em></MenuItem>
              <MenuItem value="1">📚 {t('normalSession')}</MenuItem>
              <MenuItem value="2">🔄 {t('catchupSession')}</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Active chips */}
      {hasActive && (
        <Box sx={{ px: 2.5, pb: 2, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600}>{t('gf_activeFilters')}:</Typography>
          {filters.year && (
            <Chip
              icon={<SchoolIcon />} size="small"
              label={`${filters.year} / ${parseInt(filters.year) + 1}`}
              onDelete={() => handleChange('year', '')} color="primary" variant="outlined"
              sx={{ borderRadius: 1.5, height: 24 }}
            />
          )}
          {filters.session && (
            <Chip size="small"
              label={filters.session === '1' ? `📚 ${t('normalSession')}` : `🔄 ${t('catchupSession')}`}
              onDelete={() => handleChange('session', '')} color="info" variant="outlined"
              sx={{ borderRadius: 1.5, height: 24 }}
            />
          )}
        </Box>
      )}
    </Paper>
  );
};

export default GradeFilters;
